const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.oceanagold.forwoodsafety.com',
    USER_TOKEN_URL: 'https://mv0gwi14sk.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'ap-southeast-1',
    URL: 'https://ai4ny9c7o9.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.staging.oceanagold.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.staging.oceanagold.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.staging.oceanagold.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.staging.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://auduqo2dzb.execute-api.ap-southeast-1.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
